import { render, staticRenderFns } from "./bill-confirm.vue?vue&type=template&id=d8d55232&scoped=true"
import script from "./bill-confirm.vue?vue&type=script&lang=js"
export * from "./bill-confirm.vue?vue&type=script&lang=js"
import style0 from "./bill-confirm.vue?vue&type=style&index=0&id=d8d55232&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8d55232",
  null
  
)

export default component.exports